import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import QuestionView from "../views/QuestionView.vue";
import EndView from "../views/EndView.vue";
import CounterView from "@/views/CounterView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/questions",
    name: "questions",
    component: QuestionView,
  },
  {
    path: "/end",
    name: "end",
    component: EndView,
  },
  {
    path: "/counter",
    name: "counter",
    component: CounterView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
